import React from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import useItemsAddedDialog from '../../hooks/dialogs/useItemsAddedDialog';
import { useNavigate } from 'react-router-dom';

const ItemsAddedDialog = () => {
    const itemsAddedDialog = useItemsAddedDialog();
    const {
        open,
        handleClose,
        handleGoToCart,
        productsAdded,
        translateKeyPrefix,
        translateNS,
        closeDialog,
    } = itemsAddedDialog;

    const { t } = useTranslation(translateNS, {
        keyPrefix: translateKeyPrefix,
    });
    const navigate = useNavigate();

    const goToCart = () => {
        if (handleGoToCart) {
            handleGoToCart();
        }
        closeDialog();
        navigate('/cart');
    };

    const close = () => {
        if (handleClose) {
            handleClose();
        }
        closeDialog();
    };

    const renderSwitch = () => {
        switch (productsAdded) {
            case 'all':
                return (
                    <>
                        <Typography paragraph sx={{ textAlign: 'center' }}>
                            {t('ALL_PRODUCTS_ADDED')}
                        </Typography>
                        <Alert variant="filled" severity="warning">
                            {t('DIFFERENT_PRICES')}
                        </Alert>
                    </>
                );
            case 'partially':
                return (
                    <>
                        <Typography paragraph>{t('PRODUCTS_ADDED')}</Typography>
                        <Alert variant="filled" severity="warning">
                            {t('DIFFERENT_PRICES')}
                        </Alert>
                    </>
                );
            default:
                return <Typography paragraph>{t('NO_PRODUCT')}</Typography>;
        }
    };

    const renderAddToCart = () => {
        if (productsAdded != 'none') {
            return (
                <PrimaryBtn size="small" onClick={goToCart}>
                    {t('GO_TO_CART')}
                </PrimaryBtn>
            );
        }
    };

    return (
        <Dialog open={open} onClose={close} maxWidth={'sm'} fullWidth>
            <StyledDialogTitle>
                {t('TITLE')}
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={close} />
            </StyledDialogTitle>
            <StyledDialogContent>{renderSwitch()}</StyledDialogContent>
            <DialogActions>
                <Button size="small" onClick={close}>
                    {t('BACK')}
                </Button>
                {renderAddToCart()}
            </DialogActions>
        </Dialog>
    );
};

export default ItemsAddedDialog;
